var _circle, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#3CB4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36328 9.09089L10.4542 5.45453L14.5451 9.09089",
    stroke: "#3CB4E5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 5.45453,
    x2: 10.5,
    y2: 14.5454,
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUpload);
export default __webpack_public_path__ + "static/media/circleUpload.bbb025d14d6bc0c75b3c7ad3f1d809cd.svg";
export { ForwardRef as ReactComponent };